import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Link } from '../../../models/link.interface';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-link-list',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './link-list.component.html',
  styleUrl: './link-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkListComponent {
  @Input() links: Link[];
  @Input() subtitle?: string;
}
